/* Sezzle's script treats every price on the page (the main price plus each related-product card)
   as a product and renders a widget for each one into the product page's Sezzle block, so extra
   "4 payments of ..." lines appear once the related products load. It also copies the screen-reader
   label ("Sale price") into the amount.

   This keeps only the widget that matches the main product's price, hides the rest, and strips the
   label. It re-runs whenever Sezzle redraws (variant, currency or related products loading). */
(function () {
  'use strict';
  var LABEL = /^\s*(sale price|regular price|unit price|price)\s*:?\s*/i;
  var WIDGET = '.sezzle-shopify-info-button';
  var main = null;   // the widget Sezzle drew first for the main product

  var style = document.createElement('style');
  style.textContent = WIDGET + '.zoq-sezzle-dup{display:none!important}';
  document.head.appendChild(style);

  function toNumber(text) {
    var m = (text || '').match(/\d[\d.,\s]*/);
    if (!m) return NaN;
    var s = m[0].replace(/\s/g, '');
    var lastDot = s.lastIndexOf('.'), lastComma = s.lastIndexOf(',');
    if (lastDot > -1 && lastComma > -1) {
      s = lastDot > lastComma ? s.replace(/,/g, '') : s.replace(/\./g, '').replace(',', '.');
    } else if (lastComma > -1) {
      s = /,\d{2}$/.test(s) ? s.replace(',', '.') : s.replace(/,/g, '');
    }
    return parseFloat(s);
  }

  function mainPrice() {
    var el = document.querySelector('.product-details product-price');
    return el ? toNumber(el.textContent.replace(LABEL, '')) : NaN;
  }

  function run() {
    var amounts = document.querySelectorAll('.sezzle-payment-amount');
    for (var i = 0; i < amounts.length; i++) {
      var t = amounts[i].textContent, f = t.replace(LABEL, '');
      if (f !== t) amounts[i].textContent = f;
    }

    var widgets = document.querySelectorAll(WIDGET);
    if (!main || !main.isConnected) main = widgets[0] || null;
    if (widgets.length < 2) return;
    var target = mainPrice() / 4;
    if (!isFinite(target)) { hideAllBut(main || widgets[0]); return; }

    var best = null, bestDiff = Infinity;
    for (var j = 0; j < widgets.length; j++) {
      var amount = widgets[j].querySelector('.sezzle-payment-amount');
      var diff = Math.abs(toNumber(amount && amount.textContent) - target);
      if (diff < bestDiff) { bestDiff = diff; best = widgets[j]; }
    }
    if (!best || bestDiff > 0.5) { hideAllBut(main || widgets[0]); return; }   // not matched yet: keep the original
    main = best;
    hideAllBut(best);
  }

  function hideAllBut(keep) {
    var all = document.querySelectorAll(WIDGET);
    for (var k = 0; k < all.length; k++) all[k].classList.toggle('zoq-sezzle-dup', all[k] !== keep);
  }

  function queue() { run(); }   // synchronous: runs before the next paint, so extras never flash

  run();
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
